import * as React from "react";
import ObsBadge from "../../observation/ObsBadge";
import ViewportImage from "../ViewportImage";
import { MARKER_COLOR } from "../MarkerMouseTool";

type ImageTagsProps = {
  viewportImage: ViewportImage;
};

function ImageTags({ viewportImage }: ImageTagsProps) {
  const labels: Set<string> = new Set<string>();

  const badges = viewportImage.regions
    .reduce((arr, r) => {
      if (!labels.has(r.badge.label)) {
        labels.add(r.badge.label);
        arr.push(r.badge);
      }

      return arr;
    }, [])
    .concat(
      viewportImage.markers.reduce((arr, m) => {
        const badge = {
          label: m._label,
          color: MARKER_COLOR,
        };

        if (!labels.has(badge.label)) {
          labels.add(badge.label);
          arr.push(badge);
        }

        return arr;
      }, [])
    );

  return (
    <>
      {badges.map((badge) => (
        <ObsBadge key={badge.label} color={badge.color} text={badge.label} />
      ))}
    </>
  );
}

export default ImageTags;
